$(document).ready(function() {
  $('.open-popup-link').magnificPopup({
    type:'inline',
    fixedContentPos: true,
    midClick: true, // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
    callbacks: {
    	open: function() {
          $('body').addClass('no-scroll');
          $('html').addClass('no-scroll');

        },
        close: function() {
        	$('body').removeClass('no-scroll');
          	$('html').removeClass('no-scroll');
        }
    }
  });

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const openContactForm = urlParams.get('contact_posted');
  
  if (openContactForm != null) {
    // reset URL
    let url = window.location.origin + window.location.pathname;
    if ("undefined" !== typeof history.pushState) {
      history.pushState({ id: 'homepage' }, 'CASCADE BREWERY BAR - CASCADE BREWERY CO', url);
    } else {
      window.location.assign(url);
    }
    
	// Open contact form to show message
    document.getElementById('ContactUsButton').click();
  }
});